export default __webpack_public_path__ + "static/media/Masking3.2b0f9a96.jpg";